import { BookingFlow } from "../components/BookingFlow";
import { Video } from "lucide-react";

export default function OnlineConsultation() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-testid="online-consultation-page">
      <div className="text-center mb-10">
        <span className="inline-flex items-center gap-2 bg-[#E8DAB2]/60 text-slate-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
          <Video className="w-3.5 h-3.5" /> Online Consultation Portal · 15-min slots
        </span>
        <h1 className="font-heading text-3xl md:text-4xl text-slate-900">
          Consult Dr. Prathusha from home
        </h1>
        <p className="text-slate-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
          Private, secure 15-minute consultations — every day from 9:00–11:00 AM and 7:00–9:00 PM.
          Conducted as per the Telemedicine Practice Guidelines, 2020. Not for emergencies.
        </p>
      </div>
      <BookingFlow type="online" />
    </div>
  );
}
